import React from 'react';
import Hero from './Hero/Hero';
import About from './About/About';
import MedicalApplications from './Medical/MedicalApplications';
import Capabilities from './Capabilities/Capabilities';

import Services from './Services/Services';
import ComponentsGallery from './ComponentsGallery/ComponentsGallery';
import Testimonials from './Testimonials/Testimonials';
import TrustedPartners from './TrustedPartners/TrustedPartners';

const Home = () => {
    return (
        <main>
            <Hero />
            <About />
            <MedicalApplications />
            <Capabilities />
            <Services />
            <ComponentsGallery />
            <Testimonials />
            <TrustedPartners />
        </main>
    );
};

export default Home;
